export default __webpack_public_path__ + "images/98fdde3f7bf1c5a776df39fc2070f2dc-trustly_bank_2.png";